import { ReactElement } from 'react';
import { TooltipAnchor } from '../../../services/app.service';
import { LiteracyScreeningSchoolModel } from '../../../types/LiteracyScreeningSchoolModel';
import { PanelType } from '../../../types/PanelType';
import FormInputLabel from '../../FormInputs/FormInputLabel/FormInputLabel';
import Panel from '../../Panel/Panel';

export const formatLiteracyScreeningNameWithIdentifier = (
  name: string,
  identifier: string
): string => {
  const displayName = (name ?? '').trim();
  const displayIdentifier = (identifier ?? '').trim();
  if (displayName && displayIdentifier) {
    return `${displayName} (${displayIdentifier})`;
  }
  return displayName || displayIdentifier;
};

interface LiteracyScreeningLEASchoolInformationPanelProps {
  leaNameDisplay: string;
  schoolYearDisplay: string;
  schoolList: LiteracyScreeningSchoolModel[];
  onEditSchool: (school: LiteracyScreeningSchoolModel) => void;
}

const LiteracyScreeningLEASchoolInformationPanel = ({
  leaNameDisplay,
  schoolYearDisplay,
  schoolList,
  onEditSchool,
}: LiteracyScreeningLEASchoolInformationPanelProps): ReactElement => {
  return (
    <Panel panelType={PanelType.INFO} heading="LEA & School Information">
      <div className="field-row field-row-grid-2-1">
        <div className="field-container disabled">
          <FormInputLabel
            field="leaNameDisplay"
            displayName="LEA Name"
            disabled={true}
          />
          <input
            id="leaNameDisplay"
            className="data-input"
            type="text"
            disabled
            readOnly
            value={leaNameDisplay}
            data-testid="form-readonly-lea-name"
          />
        </div>
        <div className="field-container disabled">
          <FormInputLabel
            field="schoolYearDisplay"
            displayName="School Year"
            disabled={true}
          />
          <input
            id="schoolYearDisplay"
            className="data-input"
            type="text"
            disabled
            readOnly
            value={schoolYearDisplay}
            data-testid="form-readonly-school-year"
          />
        </div>
      </div>
      <div className="table-container">
        <table cellSpacing={0} className="page-view-table">
          <thead>
            <tr>
              <th>School Name</th>
              <th>Prior End of Year</th>
              <th>Beginning of Year</th>
              <th>Middle of Year</th>
              <th>End of Year</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {schoolList.map((school, index) => {
              const rowKey =
                school.schoolIdentifier || school.id || `school-${index}`;
              return (
                <tr key={rowKey} data-testid={rowKey}>
                  <td>
                    {formatLiteracyScreeningNameWithIdentifier(
                      school.schoolName,
                      school.schoolIdentifier
                    )}
                  </td>
                  <td>{school.priorEndOfYearStatus}</td>
                  <td>{school.beginningOfYearStatus}</td>
                  <td>{school.middleOfYearStatus}</td>
                  <td>{school.endOfYearStatus}</td>
                  <td>
                    <div className="action--column">
                      <button
                        data-testid={`edit-button-${rowKey}`}
                        aria-label="Edit"
                        onClick={() => onEditSchool(school)}
                        data-tooltip-id={TooltipAnchor}
                        data-tooltip-content="Edit/View Literacy Screening"
                      >
                        <img src={'/images/icon-edit.svg'} alt="Edit" />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Panel>
  );
};

export default LiteracyScreeningLEASchoolInformationPanel;
